var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label ? _c("label", [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(),
    _c(
      "div",
      { staticClass: "input-container" },
      _vm._l(_vm.items, function (item) {
        return _c(
          "div",
          {
            key: item.value,
            staticClass: "item-choose",
            class: { "item-choose-active": item.value === _vm.model },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.onSetValue(item)
              },
            },
          },
          [_vm._v(" " + _vm._s(item.text) + " ")]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }